export default "__VITE_ASSET__GxxL3UEP__"